import React,{Fragment} from 'react';
import styled from 'styled-components';
import {motion} from 'framer-motion';

const Progress = ({prog}) => {
    return (
        <Fragment>
        {prog == 20 ?
            <ProgressBar initial={{opacity:0}} animate={{opacity:1,transition:{delay:.6}}} exit={{opacity:0}}>
                <div>
                    <motion.div initial={{width: 0}} animate={{width: '20%',transition:{duration:2}}} className="one-fith"></motion.div>
                </div>
            </ProgressBar>
        : prog == 40 ?
            <ProgressBar initial={{opacity:0}} animate={{opacity:1,transition:{delay:.6}}} exit={{opacity:0}}>
                <div>
                    <motion.div initial={{width: '20%'}} animate={{width: '40%',transition:{duration:2}}} className="two-fith"></motion.div>
                </div>
            </ProgressBar>
        : prog == 60 ?
            <ProgressBar initial={{opacity:0}} animate={{opacity:1,transition:{delay:.6}}} exit={{opacity:0}}>
                <div>
                    <motion.div initial={{width: '40%'}} animate={{width: '60%',transition:{duration:2}}} className="three-fith"></motion.div>
                </div>
            </ProgressBar>
        : prog == 80 ?
            <ProgressBar initial={{opacity:0}} animate={{opacity:1,transition:{delay:.6}}} exit={{opacity:0}}>
                <div>
                    <motion.div initial={{width: '60%'}} animate={{width: '80%',transition:{duration:2}}} className="four-fith"></motion.div>
                </div>
            </ProgressBar>
        : 
         prog == 100 ?
        <ProgressBar initial={{opacity:0}} animate={{opacity:1,transition:{delay:.6}}} exit={{opacity:0}}>
            <div>
                <motion.div initial={{width: '80%'}} animate={{width: '100%',transition:{duration:2}}} className="full"></motion.div>
            </div>
        </ProgressBar>
        : 
        <Fragment></Fragment>
        }
        </Fragment>
    )
}


const ProgressBar = styled(motion.div)`
    display: flex;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 70%;
    height: 60px;
    background: #E3E5E3;

    @media (max-width: 1060px) {
        display: none;
    }

    > div{
        width: 90%;
        display: block;
        margin: auto;
        height: 6px;
        background: #fff;
        border-radius: 100px;
        position: relative;

        .one-fith{
            position: absolute;
                display: block;
                background: #333147;
                width: 20%;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                height: 6px;
                border-radius: 100px;
           
        }

        .two-fith{
                position: absolute;
                display: block;
                background: #333147;
                width: 40%;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                height: 6px;
                border-radius: 100px;     
        }


        .three-fith{
                position: absolute;
                display: block;
                background: #333147;
                width: 60%;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                height: 6px;
                border-radius: 100px;     
        }


        .four-fith{
                position: absolute;
                display: block;
                background: #333147;
                width: 80%;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                height: 6px;
                border-radius: 100px;     
        }


        .full{
                position: absolute;
                display: block;
                background: #333147;
                width: 100%;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                height: 6px;
                border-radius: 100px;     
        }


        &.threeqarter{
            &::after{
                content: '';
                position: absolute;
                display: block;
                background: #333147;
                width: 75%;
                height: 100%;
                border-radius: 100px;
            }
        }

        &.full{
            &::after{
                content: '';
                position: absolute;
                display: block;
                background: #333147;
                width: 100%;
                height: 100%;
                border-radius: 100px;
            }
        }
    }
`;

export default Progress;